import { render, staticRenderFns } from "./BookingsCalendar.vue?vue&type=template&id=be32cb8a&"
import script from "./BookingsCalendar.vue?vue&type=script&lang=ts&"
export * from "./BookingsCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports